




























































































import Vue from "vue";
import { Locales } from "./i18n/locales";

export default Vue.extend({
  name: "App",

  components: {},

  data: () => ({
    //
  }),

  methods: {
    changeLanguage(): void {
      const newLocal =
        this.$i18n.locale === Locales.DE ? Locales.EN : Locales.DE;
      this.$i18n.locale = newLocal;
    },
  },
});
